// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__DLh46","requiredAsterisk":"Info_requiredAsterisk__Qt2Fe"};